<template>
<div>
  <div class="search-box">
    <div class="search-item">
      <label>账号名：</label>
      <a-input placeholder="请输入" v-model.trim="searchTerm.alias" />
    </div>
    <div class="search-item">
      <label>手机号：</label>
      <a-input placeholder="请输入"  v-model.trim="searchTerm.account"  />
    </div>
    <div class="search-btn" style="display: inline-block;">
      <a-button type="primary" @click="search">查询</a-button>
      <a-button  @click="reset">重置</a-button>
    </div>
  </div>
  <div class="table-header">
    <span>账号列表</span>
    <a-button type="primary" class="addbtn" @click="openModal(1)">
        +&nbsp添加账号
      </a-button>
  </div>
  
  <a-table 
  :locale="{
    emptyText: '暂无数据'
  }"
  :columns="columns" 
  @change="handleTableChange" 
  :pagination="pagination"  
  rowKey="id"  
  :data-source="data"  
  style="margin-top: 12px;" >
    <span slot="role">供应商账号</span>
    <a slot="action" slot-scope="text" >
      <span @click="openModal(3,text)" class="row-edit">编辑</span>
      <span @click="openModal(2,text)">修改密码</span> 
    </a>
  </a-table>
  <add-modal ref="addAccount" mode='2' @getdata="getdata"></add-modal>
  <edit-modal ref="editAccount" mode='2' @getdata="getdata"></edit-modal>
   <updata-modal ref="updataAccount" mode='2' @getdata="getdata"></updata-modal>
</div>
  
</template>
<script>
import page from "@/assets/mixin/page.js";
import addModal from "./addModal"
import editModal from "./editModal"
import updataModal from "./updataModal"
const columns = [
  {
    title: '账号名',
    dataIndex: 'alias',
    key: 'alias',
  },
  {
    title: '手机号',
    dataIndex: 'account',
    key: 'account',
  },
  {
    title: '角色',
    key: 'role',
    scopedSlots: { customRender: 'role' },
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  mixins: [page],
  components:{addModal,editModal,updataModal},
  data() {
    return {
      data:[],
      columns,
    };
  },
  created(){
    this.getdata()
  },
  methods:{
    reset(){
      this.searchTerm = {};
      this.getdata();
    },
    search(){
      this.pagination.current = 1;
      // ;
      this.getdata();
    },
    getdata(index){
      let params = {...this.searchTerm}
      params.pageNum = index||this.pagination.current
      this.pagination.current = params.pageNum;
      this.$http.post('/supplier/queryRecordList',params).then(res=>{
        this.data = res.rows
        this.pagination.total = res.count;
      })
    },
    openModal(index,text){
      if (index=='1') {
        this.$refs.addAccount.showModal()
      } else if(index=='2') {
        this.$refs.editAccount.showModal(text)
      }else if(index=='3') {
        this.$refs.updataAccount.showModal(text)
      }
    },
  }
};
</script>
<style lang="less" scoped>

.table-header{
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  span{
    font-size:16px;
    font-weight:400;
    color:rgba(0,0,0,0.85);
  }
}
.row-edit{
  display: inline-block;
  margin-right: 24px;
}
</style>
